export const RESPONSE_TIME_OFF = "off"
export const RESPONSE_TIME_CUSTOM = "custom"

const PRESETS = [
	{ hours: 1, label: "1 hour" },
	{ hours: 4, label: "4 hours" },
	{ hours: 8, label: "8 hours" },
	{ hours: 24, label: "24 hours" },
	{ hours: 48, label: "2 days" },
] as const

export const RESPONSE_TIME_OPTIONS = [
	{ value: RESPONSE_TIME_OFF, label: "Off" },
	...PRESETS.map((preset) => ({
		value: preset.hours.toString(),
		label: preset.label,
	})),
	{ value: RESPONSE_TIME_CUSTOM, label: "Custom", separatorBefore: true },
]

export function responseTimeSelection(
	hours: number | null,
	customMode: boolean,
): string {
	if (customMode) return RESPONSE_TIME_CUSTOM
	if (hours === null || hours <= 0) return RESPONSE_TIME_OFF
	return PRESETS.some((preset) => preset.hours === hours)
		? hours.toString()
		: RESPONSE_TIME_CUSTOM
}

// Only call for Off or a preset; Custom saves through the hours field.
export function hoursForSelection(value: string): number | null {
	return value === RESPONSE_TIME_OFF ? null : Number(value)
}
